import { Guid } from 'guid-typescript';
import { StringMap, TOptions } from 'i18next';

export enum MessageType {
  Info,
  Success,
  Error,
}

export class Message {
  public id: string;
  public type: MessageType;
  public text?: string;
  public isTextTranslationKey = false;
  public textTranslationKeyOptions?: TOptions<StringMap>;
  public autoClose: boolean;
  public manualCloseEnabled = true;
  public hideDuration?: number = 5000;
  public actionText?: string;
  public actionCallback?: () => void;

  private constructor(type: MessageType, text: string, autoClose = true) {
    this.id = Guid.create().toString();
    this.type = type;
    this.text = text;
    this.autoClose = autoClose;
  }

  static info(text: string, autoClose = true): Message {
    return new Message(MessageType.Info, text, autoClose);
  }

  static success(text: string, autoClose = true): Message {
    return new Message(MessageType.Success, text, autoClose);
  }

  static error(text: string, autoClose = true): Message {
    return new Message(MessageType.Error, text, autoClose);
  }

  public withAction(text: string, callback: () => void): Message {
    this.actionText = text;
    this.actionCallback = callback;
    return this;
  }

  public withTranslatedText(): Message {
    this.isTextTranslationKey = true;
    return this;
  }

  public withTranslatedTextAndOptions(
    textTranslationKeyOptions: TOptions<StringMap>,
  ): Message {
    this.isTextTranslationKey = true;
    this.textTranslationKeyOptions = textTranslationKeyOptions;
    return this;
  }

  public withoutManualClose(): Message {
    this.manualCloseEnabled = false;
    return this;
  }
}

export const syncFailed =
  Message.error('errors.sync_failed').withTranslatedText();

export interface NotificationState {
  messages: Message[];
}

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export interface AddMessageAction {
  type: typeof ADD_MESSAGE;
  message: Message;
}

export interface ClearMessageAction {
  type: typeof CLEAR_MESSAGE;
  id: string;
}

export type NotificationActionTypes = AddMessageAction | ClearMessageAction;
